import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import Modal from '../shared/Modal'
import SummaryForm from '../SummaryForm'
import useSummaryFormData from '../SummaryForm/hooks/useSummaryFormData'
import Loader from '../shared/Loader'
import ErrorAlert from '../shared/Export/ErrorAlert'

const CreateSummaryModal = ({ collectId, buttonClassName }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { formOptions, error } = useSummaryFormData(collectId, null, { enabled: isOpen })

  const handleOpen = useCallback(() => setIsOpen(true), [])
  const handleClose = useCallback(() => setIsOpen(false), [])

  const handleSuccess = useCallback(() => {
    window.location.href = `/collects/${collectId}/summaries?created=true`
  }, [collectId])

  const title = (
    <>
      <i className="fas fa-file-alt mr-1" />
      {'Configuration d\'un nouveau récapitulatif'}
    </>
  )

  const renderBody = () => {
    if (error)
      return <ErrorAlert message={error} />
    if (!formOptions)
      return <Loader />
    return (
      <SummaryForm
        collectId={collectId}
        formOptions={formOptions}
        onCancel={handleClose}
        onSuccess={handleSuccess}
      />
    )
  }

  return (
    <>
      <button
        className={buttonClassName}
        type="button"
        onClick={handleOpen}
      >
        <i className="fas fa-plus mr-1" />
        {' Créer un nouveau récapitulatif'}
      </button>
      <Modal
        isOpen={isOpen}
        title={title}
        onClose={handleClose}
      >
        {renderBody()}
      </Modal>
    </>
  )
}

CreateSummaryModal.propTypes = {
  buttonClassName: PropTypes.string,
  collectId: PropTypes.number.isRequired
}

CreateSummaryModal.defaultProps = {
  buttonClassName: 'btn btn-primary float-md-right mt-2 mt-md-0'
}

export default CreateSummaryModal
